var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":'https://open-explorer.io/#/accounts/' + _vm.name}},[_vm._v(_vm._s(_vm.name)+_vm._s(_vm.id && "(" + _vm.id + ")"))])}
var staticRenderFns = []

export { render, staticRenderFns }